/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { application_user } from '../models/application_user';
import type { changePasswordPayload } from '../models/changePasswordPayload';
import type { dataTablesRequest } from '../models/dataTablesRequest';
import type { userPayload } from '../models/userPayload';
import type { vw_application_user } from '../models/vw_application_user';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class UserService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postUserDataTables({
        requestBody,
    }: {
        requestBody: dataTablesRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/user/dataTables',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Retrieve a list of users
     * @returns any A list of users
     * @throws ApiError
     */
    public getUsers(): CancelablePromise<Array<{
        id?: string;
        name?: string;
    }>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users',
        });
    }

    /**
     * Get user profile
     * @returns vw_application_user The User Profile
     * @throws ApiError
     */
    public getUserProfile(): CancelablePromise<vw_application_user> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/profile',
            errors: {
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get user by ID
     * @returns any The user data
     * @throws ApiError
     */
    public getUser({
        id,
    }: {
        /**
         * The user ID
         */
        id: string,
    }): CancelablePromise<{
        id?: string;
        name?: string;
        email?: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a user by ID
     * @returns any User deleted successfully
     * @throws ApiError
     */
    public deleteUser({
        id,
    }: {
        /**
         * The user ID
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/user/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a new application user
     * @returns any User created successfully
     * @throws ApiError
     */
    public postUser({
        requestBody,
    }: {
        requestBody: userPayload,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update an existing user
     * @returns any User updated successfully
     * @throws ApiError
     */
    public putUser({
        requestBody,
    }: {
        requestBody: application_user,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Deactivate a user
     * @returns any User deactivated successfully
     * @throws ApiError
     */
    public patchUserDeactivate({
        id,
    }: {
        /**
         * The user ID
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/user/deactivate/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Reactivate a user
     * @returns any User reactivated successfully
     * @throws ApiError
     */
    public patchUserReactivate({
        id,
    }: {
        /**
         * The user ID
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/user/reactivate/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Change Password
     * @returns any User created successfully
     * @throws ApiError
     */
    public postUserChangePassword({
        requestBody,
    }: {
        requestBody: changePasswordPayload,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/user/change/password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

}
